import { SendEmailMutation } from "src/api/Email";
import { useForm } from "src/components/forms/Form";
import { InputItem } from "src/components/inputs/InputItem";
import { InputText } from "src/components/inputs/InputText";
import InputTextarea from "src/components/inputs/InputTextarea";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import message from "src/utils/message";
import { modals, useModal } from "src/utils/modals";
import { EmailType, sendEmailVariables } from "types/code-generator";
import { BorderButton } from "../buttons/BorderButton";
import Modal from "./Modal";

interface Props {
  title?: string;
  sendToSupport?: boolean;
  deleteAccount?: boolean;
  testEmail?: boolean;
}

export const ContactSupportModal = modals.create((props: Props) => {
  const store = useStore();
  const modal = useModal();
  const form = useForm();

  async function send() {
    form.validateFields(async (err, values) => {
      if (err) {
        console.log("errors", err);
        return;
      }

      let body = form.getFieldValue("message");

      if (props.testEmail) {
        body = `This is a test email from ${store.organization.title}.`;
      }

      let replyTo = form.getFieldValue("email");
      let name = replyTo;
      let html = `
        <p>${replyTo} has a question/message:</p>
        <p>${body}</p>
      `;
      let type = undefined;

      if (store.user) {
        replyTo = store.user.email;
        name = `${store.user.firstName} ${store.user.lastName}`;
        html = `
          <p><a href="https://${store.organization.subdomain}.captyn.com/admin/users/${store.user.id}">${name}</a> (${replyTo}) has a question/message:</p>
          <p>${body}</p>
        `;
      }

      let sendToOrganization = true;
      let sendToSupport = props.sendToSupport;
      const additionalEmails = [];

      if (sendToSupport) {
        sendToOrganization = false;
        additionalEmails.push("support@captyn.com");
      }

      let subject = `Message from ${name}`;

      if (props.deleteAccount) {
        subject = `Delete Account Request from ${name}`;
        html = `
          <p>${replyTo} has a delete account request:</p>
          <p>${body}</p>
        `;
      }

      if (props.testEmail) {
        subject = `Test Email from ${store.organization.title}`;
        html = `
          <p>${body}</p>
        `;
        sendToOrganization = false;
        additionalEmails.push(form.getFieldValue("email"));
        type = EmailType.Code;
        replyTo = undefined;
      }

      const variables: sendEmailVariables = {
        data: {
          users: [],
          additionalEmails,
          sendToOrganization,
          subject,
          replyTo,
          organizationId: store.organization.id,
          html,
          type,
        },
      };

      await apiClient(SendEmailMutation, {
        variables,
      });

      modal.hide();

      message.success("Email sent");
    });
  }

  let title = "Send Support Message";

  if (props.title) {
    title = props.title;
  }

  return (
    <Modal
      visible={modal.visible}
      handleCancel={modal.hide}
      afterClose={modal.remove}
      title={title}
      footer={
        <>
          <BorderButton type="submit" onClick={send}>
            Send
          </BorderButton>
          <BorderButton onClick={modal.hide}>Cancel</BorderButton>
        </>
      }
    >
      {!store.user && (
        <InputItem
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter an email" }]}
          form={form}
        >
          <InputText placeholder="Your email address" type="email" />
        </InputItem>
      )}

      {props.testEmail && (
        <InputItem
          label="Email"
          name="email"
          rules={[{ required: true, message: "Please enter an email" }]}
          form={form}
        >
          <InputText placeholder="Test recipient" type="email" />
        </InputItem>
      )}

      {props.deleteAccount && (
        <p>We will confirm your account deletion within 5 business days.</p>
      )}

      {!props.testEmail && (
        <InputItem
          label="Question/Message"
          name="message"
          rules={[{ required: true, message: "Please enter a message" }]}
          form={form}
        >
          <InputTextarea placeholder="Your message" />
        </InputItem>
      )}
    </Modal>
  );
});
